const reducer = (state = [], action) => {
  switch (action.type) {
    case "FETCH_LABS":
      return action.payload;
    case "ADD_LABS":
      return [...state, action.payload];
    case "UPDATE_LABS":
      return state.map((item) =>
        item.id === action.payload.id ? { ...action.payload } : item
      );
    case "REMOVE_LABS":
      return state.filter((s) => s.id !== action.payload);
    case "CLEAR_LABS":
      return [];
    default:
      return state;
  }
};
export default reducer;
